module.exports = __webpack_public_path__ + "img/carousel-hsp2-1.1532e87d.png";